import React from 'react';
import JobListings from '../Careers/JobListing';
import FilterSidebar from '../Careers/FilterSidebar';

const Careers = () => {
  return (
    <div className="flex container mx-auto px-4 md:px-0 font-nunito mt-32">
      <FilterSidebar />
      <div className="flex-1 ml-8">
        <JobListings />
      </div>
    </div>
  );
};

export default Careers;
